export function singleProductSlider() {
    const $body = $("body");
    const $productImagesGallery = $(".product-images-gallery");
    const $productImagesThumbs = $(".product-images-thumbs");
    $productImagesGallery.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        fade: true,
        asNavFor: $productImagesThumbs,
        mobileFirst: true,
        responsive: [
            {
                breakpoint: 1199,
                settings: {
                    arrows: false,
                }
            },
        ]
    });
    $productImagesThumbs.slick({
        slidesToShow: 6,
        slidesToScroll: 1,
        asNavFor: $productImagesGallery,
        dots: false,
        arrows: true,
        focusOnSelect: true,
        vertical: true,
        verticalSwiping: true,
    });
    let oldColorSelected = "";
    $body.on("click", function (e) {
        let colorSelected = $(this).find(".single-product-variable-items li.selected").attr("title");
        let sliderInitColor = $body.find(".product-images-gallery .slick-current .woocommerce-product-gallery__image").data("color");
        if (colorSelected !== oldColorSelected && colorSelected) {
            if (colorSelected.toLowerCase() !== sliderInitColor) {
                oldColorSelected = colorSelected;
                $body.find(".woocommerce-product-gallery__image").each(function () {
                    let $this = $(this)
                    if ($this.data("color") === colorSelected.toLowerCase()) {
                        let colorIndex = $this.parents(".slick-slide").data("slick-index");
                        $productImagesGallery.slick('slickGoTo', colorIndex);
                        $productImagesThumbs.slick('slickGoTo', colorIndex);
                    }
                });
            }
        }
    });
    $(window).on("load", function () {
        let colorSelected = $body.find(".single-product-variable-items li.selected").attr("title");
        let sliderInitColor = $body.find(".product-images-gallery .slick-current .woocommerce-product-gallery__image").data("color");
        if (colorSelected !== oldColorSelected && colorSelected) {
            if (colorSelected.toLowerCase() !== sliderInitColor) {
                oldColorSelected = colorSelected;
                $body.find(".woocommerce-product-gallery__image").each(function () {
                    let $this = $(this)
                    if ($this.data("color") === colorSelected.toLowerCase()) {
                        let colorIndex = $this.parents(".slick-slide").data("slick-index");
                        $productImagesGallery.slick('slickGoTo', colorIndex);
                        $productImagesThumbs.slick('slickGoTo', colorIndex);
                    }
                });
            }
        }
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/singleProductSlider.js